<template>
  <button :class="classes"
          v-focus="focus"
          @click="$emit('click')">
    <slot/>
  </button>
</template>

<script>
export default {
  directives: {
    focus: {
      inserted: (el, binding) => {
        if (binding.value) el.focus();
      },

      componentUpdated: (el, binding) => {
        if (binding.value && !binding.oldValue) el.focus();
      },
    },
  },

  props: {
    pull: String,
    color: String,
    focus: Boolean,
  },

  computed: {
    classes: function classes() {
      const out = ['btn'];

      if (this.pull === 'right' || this.pull === 'left') {
        out.push(`pull-${this.pull}`);
      }

      if (this.color) {
        out.push(`btn-${this.color}`);
      }

      return out;
    },
  },
};
</script>

<style scoped>
.btn {
  text-transform: uppercase;
  color: #222;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  letter-spacing: 0.04em;
  cursor: pointer;

  margin: 3px;
  padding: 0 16px;
  min-width: 64px;
  min-height: 34px;
  line-height: 34px;
  vertical-align: middle;
  text-align: center;

  border: 0;
  border-radius: 2px;
  background: rgba(158,158,158,.1);
  box-shadow:
    0 1px 5px 0 rgba(0,0,0,.12),
    1px 2px 2px 0 rgba(0,0,0,.14),
    1px 3px 1px -2px rgba(0,0,0,.2);

  transition:
    box-shadow .2s ease-in-out,
    background .2s ease-in-out,
    color .2s ease-in-out;
}
.btn:hover,
.btn:focus {
  background: rgba(158,158,158,.2);
  box-shadow:
    0 1px 8px 0 rgba(0,0,0,.15),
    1px 4px 5px 0 rgba(0,0,0,.2),
    1px 2px 8px -2px rgba(0,0,0,.3);
}
.btn:active {
  background: rgba(158,158,158,.2);
  transition: box-shadow .05s ease-out;
  box-shadow: 0 1px 5px 0 rgba(0,0,0,.12);
}

.btn.btn-blue {
  color: #fff;
  background: #428BCA;
}
.btn.btn-orange {
  color: #fff;
  background: #ff4411;
}

.btn.pull-left {
  float: left;
}
.btn.pull-right {
  float: right;
}

.btn:focus {
  outline: 0;
}
.btn::-moz-focus-inner {
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/FormButton.vue